import React from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { Map, DataLayer, Feature } from 'google-react-maps';
import { Container, UserSelect } from 'components';
import * as Api from 'api';
import { SketchPicker } from 'react-color';
import * as Permissions from 'permissions';
import { connect } from 'react-redux';
import { hasPermission } from 'actions';

const copy = j => JSON.parse(JSON.stringify(j))

class ListItem extends React.Component {
  state = { deleting: false };
  handleDelete = () => {
    if(!this.state.deleting) {
      this.setState({ deleting: true });
    } else if(this.props.onDelete) {
      this.setState({ deleting: false });
      this.props.onDelete();
    }
  }
  cancelDelete = () => {
    this.setState({ deleting: false });
  }
  render() {
    const { deleting } = this.state;
    const {
      _id,
      name,
      features,
      assigned_to_users,
      ...props
    } = this.props;
    const userStyle = { color: '#fff' };
    return (
      <div style={{
        padding: 5,
        paddingLeft: 8,
        marginBottom: 4,
        border: '1px solid #333',
        borderRadius: 4,
        ...props.style
      }} onClick={e => props.onClick()}>
        <span>{name}</span>
        {assigned_to_users.map(user =>
          <div
            style={{
              ...userStyle,
              paddingTop: 3,
              paddingBottom: 3,
              marginLeft: 0,
              marginBottom: 1,
            }}
            key={user._id}
          >
            <span style={{
              ...userStyle,
              marginLeft: 10,
              color: '#eeeeee',
              background: '#588f95',
              borderRadius: 10,
              paddingLeft: 5,
              paddingRight: 5,
              marginRight: 3
            }}>
              <i className='fa fa-user' />
            </span>
            <span style={{
              ...userStyle
            }}>
              {user && user.name && user.name.first && user.name.last && `${user.name.first} ${user.name.last}` || user.username}
            </span>
          </div>
        )}
        <span onClick={e => props.onEdit()} className='pl-sm'>
          <i className='fa fa-edit'></i>
        </span>
        {!deleting ? (
          <span className='pl-sm text-danger' onClick={e => this.handleDelete()}>
            <i className='fa fa-trash' />
          </span>
        ) : (
          <span className='pl-sm'>Are you sure? <a onClick={e => this.handleDelete()}>Yes</a> or <a onClick={e => this.cancelDelete()}>No</a></span>
        )}
      </div>
    );
  }
}

const List = props => (<div>{props.children}</div>)
const AddButton = props => (
  <a {...props} onClick={e => {
    e.preventDefault();
    props.onClick(e);
  }}><i className='fa fa-plus'></i> Add</a>
);

class RegionForm extends React.Component {
  constructor(props) {
    super(props);
    const {
      onSave,
      onCancel,
      ...region
    } = props;

    this.state = {
      dirty: false,
      ...(region)
    }

    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  handleSave() {
    const { _id, name, features, assigned_to_users } = this.state;
    this.props.onSave({ _id, name, features, assigned_to_users });
  }
  handleCancel() {
    if(this.state.dirty && !this.state.cancelling) {
      this.setState({
        cancelling: true
      });
    }

    if(this.state.cancelling || !this.state.dirty) {
      this.props.onCancel();
    }
  }
  handleChange(name, value) {
    this.setState({
      [name]: value,
      dirty: true
    });
  }
  render() {
    const {
      _id,
      saving,
    } = this.props;

    const {
      dirty,
      name,
      cancelling,
      assigned_to_users,
      ...region
    } = this.state;

    return (
      <div>
        <Row>
          <Col xs={12}>
            {!_id ? <h4>New Region</h4> : <h4>Update Region</h4>}
            <Row>
              <Col className='mb-sm' xs={12}>
                <label className='control-label'>Name</label>
                <input type='text' className='form-control' placeholder='Name' onChange={e => this.handleChange('name', e.target.value)} value={name || ''} />
              </Col>
              <Col className='mb-sm' xs={12}>
                <label className='control-label'>Assigned To</label>
                <UserSelect multi onChange={items => this.handleChange('assigned_to_users', items.map(item => item && item.value || []))} value={(assigned_to_users || []).map(item => typeof item === 'string' && item || item._id)} placeholder='Select Users' />
              </Col>

              {!cancelling ? <Col md={6}>
                <Button onClick={e => this.handleCancel()} block bsStyle='default'>Cancel</Button>
              </Col>: null}
              {!cancelling ? <Col md={6}>
                <Button onClick={e => !saving ? this.handleSave() : null} block bsStyle='primary'><span>{saving && (<i className='fa fa-spinner fa-spin' />) || null} Save</span></Button>
              </Col> : null}
              {cancelling ? (
                <Col md={12}>
                  <p>Are you sure?</p>
                  <Col xs={6}>
                    <Button onClick={e => {
                      this.setState({ cancelling: false });
                    }} block bsStyle='default'>No</Button>
                  </Col>
                  <Col xs={6}>
                    <Button onClick={e => this.handleCancel()} block bsStyle='primary'>Yes</Button>
                  </Col>
                </Col>
              ) : null}
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

class SalesRegionManager extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      regions: [],
      downloading: false,
      drawing_mode: null,
      creating_region: false,
      editing_region: null,
      saving_region_id: '',
      drawing_in_region: '',
      editing_region_id: '',
      deleting_region_id: '',
    }

    this.error = this.error.bind(this);
    this.addRegion = this.addRegion.bind(this);
    this.updateRegion = this.updateRegion.bind(this);
    this.removeRegion = this.removeRegion.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleCreateFeature = this.handleCreateFeature.bind(this);
  }
  startEditingRegion = region => {
    this.setState({
      editing_region: copy(region)
    });
  }
  resize() {
    const container = $('.canvassing-regions-manager');
    const windowHeight = $(window).outerHeight();
    const top = container.offset().top;
    const height = windowHeight - top - 1;
    container.height(height);
  }
  getRegion(id) {
    const { regions } = this.state;
    return regions.find(region => region._id == id)
  }
  removeRegion(region) {
    if(!this.mounted) return;
    this.setState({
      regions: this.state.regions.filter(r => r._id != region._id)
    });
  }
  addRegion(region) {
    if(!this.mounted) return;
    this.setState({
      regions: [
        region,
        ...this.state.regions
      ],
      creating_region: false,
    });
  }
  handleCreateFeature(json) {
    this.setState({
      editing_region: {
        ...this.state.editing_region,
        features: [ json ]
      }
    });
  }
  handleUpdateFeatureColor = color => {
    const region = this.state.editing_region;
    console.log(color)
    if(region.features.length > 0) {

      const feature = this.state.editing_region.features[0];
      this.setState({
        editing_region: {
          ...region,
          features: [
            {
              ...feature,
              properties: {
                ...feature.properties,
                fillColor: color.hex
              }
            }
          ]
        }
      });
    }
  }
  handleFeatureChange = (json) => {
    const region = this.state.editing_region;

    this.setState({
      editing_region: {
        ...region,
        features: [
          json
        ]
      }
    });
  }
  updateRegion = (region) => {
    if(!this.mounted) return;
    const { regions } = this.state;
    let idx = 0;

    for (var i = 0; i < regions.length; i++) {
      if(regions[i]._id == region._id) {
        idx = i;
        break;
      }
    }
    this.setState({
      regions: [
        ...regions.slice(0, idx),
        region,
        ...regions.slice(idx, regions.length)
      ],
      saving_region_id: '',
      creating_region: false
    });
  }
  handleDelete = (region) => {
    Api.deleteCanvassingRegion(region._id)
      .then(response => {
        if(!this.mounted) return;
        this.removeRegion(region);
      })
      .catch(this.error);
  }
  error(error) {
    if(!this.mounted) return;
    this.setState({
      error,
      creating_region: false,
      editing_region_id: '',
      deleting_region_id: ''
    });
  }
  handleSave(region) {
    const {
      _id,
      name,
      assigned_to_users,
      features
    } = region;
    this.setState({ saving: true });

    if(!_id) {
      //Create New
      return Api
        .createCanvassingRegion({ name, assigned_to_users, features })
        .then(region => {
          this.addRegion(region);
          return region;
        })
        .catch(this.error)
        .then(region => this.setState({ saving: false, creating_region: false }, () => this.startEditingRegion(region)));
    } else {
      //Save current.
      return Api
        .updateCanvassingRegion({ _id, name, assigned_to_users, features })
        .then(this.updateRegion)
        .catch(this.error)
        .then(f => this.setState({ saving: false, editing_region: null }));
    }
  }
  handleCancel() {
    this.setState({
      creating_region: false,
      editing_region: null,
    })
  }
  fetchRegions = () => {
    Api
      .fetchCanvassingRegion()
      .then(({ results, ...data }) => {
        this.setState({
          downloading: false,
          regions: results,
          ...data
        });
      })
      .catch(this.error);
  }
  componentDidMount() {
    this.mounted = true;
    this.fetchRegions();
    this.resize();
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    const {
      saving,
      regions,
      drawing_mode,
      swath_opacity,
      editing_region,
      editing_region_id,
      creating_region,
      deleting_region_id
    } = this.state;

    if(!this.props.hasPermission(Permissions.CREATE_CANVASSING_REGIONS)) {
      return null;
    }

    return (
      <Container
        title='Canvassing Regions'
        removeClassNames
        style={{ paddingLeft: '88px', paddingBottom: 0, paddingRight: 15 }}
        className='canvassing-regions-manager'
      >
        <Row style={{ height: '100%', padding: 0 }}>
          <Col style={{height: '100%'}} className={'bg-dark'} xs={3}>
            {!creating_region && !editing_region ? (
              <div className='mt-lg mb-sm'>
                <div className='clearfix'>
                  <AddButton onClick={e => this.setState({ creating_region: true })} className='pull-right clearfix' style={{ display: 'block' }} href='#' />
                </div>
                <List>
                  {regions.map(
                    region => (
                      <ListItem
                        {...region}
                        key={region._id}
                        style={{ cursor: 'pointer' }}
                        onEdit={f => this.startEditingRegion(region)}
                        onClick={e => {}}
                        onDelete={e => this.handleDelete(region)}
                      />
                    )
                  )}
                </List>
              </div>
            ) : (
              <RegionForm {...(editing_region || {})} saving={saving} onSave={formFeature => this.handleSave({ ...formFeature, features: editing_region && editing_region.features || [] })} onCancel={this.handleCancel} />
            )}
            {editing_region ? (
              <div>
                <hr />
                <Row>
                  {editing_region.features.length == 0 ?
                    <div>
                      <Col xs={12}>
                        <label>Drawing Mode</label>
                      </Col>
                      <Col xs={6}><Button onClick={e => this.setState({ drawing_mode: undefined })} block bsStyle={!drawing_mode ? 'primary' : 'default'}><i className='fa fa-hand-pointer-o'></i></Button></Col>
                      <Col xs={6}><Button onClick={e => this.setState({ drawing_mode: 'Polygon' })} block bsStyle={drawing_mode == 'Polygon' ? 'primary' : 'default'}><i className='fa fa-plus-square-o'></i></Button></Col>
                      <hr />
                    </div>
                  :null}

                  {editing_region.features.length == 1 ? (
                    <Col className='text-dark' xs={12}>
                      <label className='text-light mt-sm'>Region Color Picker</label>
                      <SketchPicker
                        style={{ width: '100%' }}
                        color={ editing_region.features[0].properties && editing_region.features[0].properties.fillColor || '#000' }
                        onChangeComplete={ this.handleUpdateFeatureColor }
                      />
                    </Col>
                  ) : null}
                </Row>
              </div>
            ) : null}
          </Col>
          <Col xs={9} style={{ height: '100%' }}>
            <Map
              api-key="AIzaSyCWuH5SGDikY4OPSrbJxqTi4Y2uTgQUggw"
              style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0 }}>
              {regions
                .filter(i => editing_region ? i._id != editing_region._id : true)
                .map((region, idx) => (
                  <DataLayer
                    key={region._id}
                    visible
                    fillOpacity={swath_opacity}
                    zIndex={idx}
                  >
                    {region.features.map(feature => (
                      <Feature
                        onClick={e => this.startEditingRegion(region)}
                        key={`${region._id}${region._id}${idx}`}
                        geoJson={feature}
                        id={`${ feature._id || idx }`}
                      />
                    ))}
                  </DataLayer>
                )
              )}
              {editing_region ? (
                <DataLayer
                  visible
                  onCreate={this.handleCreateFeature}
                  drawingMode={editing_region.features.length == 0 ? this.state.drawing_mode: null}
                  zIndex={1000}
                >
                  {editing_region.features.map((feature, idx) => (
                    <Feature
                      editable
                      onChange={json => this.handleFeatureChange(json)}
                      key={`${editing_region._id}${feature._id}${idx}`}
                      geoJson={feature}
                      id={`${ feature._id || idx }`}
                    />
                  ))}
                </DataLayer>
              ) : null}
            </Map>
          </Col>
        </Row>
      </Container>
    )
  }
}

export default connect(e => ({}), { hasPermission })(SalesRegionManager);



// WEBPACK FOOTER //
// ./src/browser/components/clients/sales-regions-manager.js